<template>
    <div style="height: 300px;">
        <div style="height: 100%;min-height: 200px;" id="query_box" v-show="data.tableDataType == 2">
            <l-query-search v-if="data.showSearch" :buttomList="fliterBtns" :ParamJsonList="ParamJsonList" :configData="data" @getList="getList" :showReset="false" :viewMode="false" ref="customSearch" :searchText="'查询'"></l-query-search>
            <div id="table_btn" :style="{'height':data.showSearch ? 'calc(100% - 66px)': '100%'}">
                <l-customTable ref="customTable" :bottomData="bottomData" :headerData="headerData" :buttomList="fliterInBtns" :tableData="tableData" />
            </div>
        </div>
        <div v-show="data.tableDataType == 1">
          <l-custom-form-table :isPreview="true" :designConfig="data"></l-custom-form-table>
        </div>
      <el-button
        title="复制"
        @click.stop="handleWidgetClone(index)"
        class="drag-table-action-clone"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="primary"
      >
        <i class="el-icon-copy-document"></i>
      </el-button>
      <el-button
        title="删除"
        @click.stop="handleWidgetDelete(index)"
        class="drag-table-action-delete"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="danger"
      >
        <i class="el-icon-delete"></i>
      </el-button>
    </div>
  </template>
  <script>
  const dbsourceApi = () => {
    return window.$api.data.dbsource
};
  import mixin from "./mixin";
  export default {
    name: "drag-form-custom-table",
    mixins: [mixin()],
    props: {
        data: {
            type: Object,
            default: () => {
            return {}
            }
        },
    },
    data() {
      return {
        form: {},
        headerData:[],
        tableData:[],
        loading:false,
        bottomData:''
      };
    },
    computed: {
        fliterBtns(){
            return this.data.tableBtns.filter(x => !x.isRowBtn)
        },
        fliterInBtns(){
            return this.data.tableBtns.filter(x => x.isRowBtn)
        },
        ParamJsonList() {
            return JSON.parse(this.data.ParamJsonList)
        },
        // headerData(){
        //   return JSON.parse(this.data.fieldOptions)
        // }
    },
    watch: {
        'data.ParamJsonList': {
            handler(newValue) {
                console.log('data对象发生变化');
                console.log(newValue,'data对象发生变化');
      console.log(this.data,'进来123124bbb');
                // 你可以在这里处理user对象任何层级属性的变化
                this.getOption()
            },
            deep: true // 开启深度监听
        },
        'data.fieldOptions':{
          handler(newValue) {
            console.log(JSON.parse(newValue),'列对象发生变化');
      console.log(this.data,'进来123124ccc');
            this.headerData = JSON.parse(this.data.fieldOptions)
            this.$nextTick(() => {
                this.$refs.customTable.processData()
            })
            console.log(this.headerData);
          },
          deep: true // 开启深度监听
        }
    },
    mounted(){
      this.getOption()
      console.log('初始化');
      console.log(this.data,'进来123124aaaa');

    },
    methods: {
        async getList(list){
            console.log(list);
            var obj = {}
            list.forEach(item => {
                var bol = true
                for(var i in this.lr_dataParamsSource){
                if(i == item.f_DefaultValue){
                    obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                    bol= false
                }else{
                    if(bol){
                    obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                    }
                }
                }
            })
            var pamdata = {
                queryJson:obj
            }
            let res = await dbsourceApi().newGetDataListByParamter(this.data.dataCode,pamdata)
            this.tableData = res.data.data
        },
      handleWidgetClone(index) {
        let cloneData = this.$deepClone(this.myComponent);
        cloneData.prop = Date.now() + "_" + Math.ceil(Math.random() * 99999);
        cloneData.table = "";
        cloneData.field = "";
        this.setAllProp(cloneData.children);
        this.parentComponents.splice(index, 0, cloneData);
        this.$nextTick(() => {
          this.handleSelectWidget(index + 1);
          this.$emit("change");
        });
      },
      handleFormClickAdd(item) {
        console.log(item);
        console.log(this.myComponent);
        // this.childrenComponents.push(item);
        // this.$refs.dragFormWraper.handleFormAdd(
        //   { newIndex: this.childrenComponents.length - 1 },
        //   true
        // );
      },
      async getOption() {
            console.log(this.data,'进来123124');
            var queryArr = JSON.parse(this.data.ParamJsonList)
            if(queryArr){
                var obj = {}
                
                queryArr.forEach(item => {
                var bol = true
                for(var i in this.lr_dataParamsSource){
                    if(i == item.f_DefaultValue){
                        obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                        bol= false
                    }else{
                        if(bol){
                            if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                            obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                            }else{
                            obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                            }
                        }
                    }
                }
                // obj[item.f_ParamName.slice(1)] = item.f_DefaultValue ? item.f_DefaultValue : item.f_NewDefaultValue ? item.f_NewDefaultValue : ''
                })
                var pamdata = {
                queryJson:obj
                }
                var summary = this.data.bottomSummary || []
                var summaryArr = []
                summary.forEach(item => {
                    if(item.f_SummaryType){
                        summaryArr.push({
                            fieldName:item.f_ColumnField,
                            fieldAliasName:item.f_ColunmName ? item.f_ColunmName : item.f_ColumnField,
                            filedSummaryType:item.f_SummaryType,
                        })
                    }
                })
                console.log(summaryArr,'summaryArr');
                if(summaryArr.length){
                    let sumQuery = {
                        code:this.data.dataCode,
                        queryJson:JSON.stringify(obj),
                        lstFieldSummaryConfig:summaryArr
                    }
                    console.log(sumQuery,'sumQuery');
                    let res = await dbsourceApi().getDataSummaryinfo(this.data.dataCode,sumQuery)
                    console.log(res,'res');
                    this.bottomData = res.data.data
                }
                if(this.data.dataCode){
                    let res = await dbsourceApi().newGetDataListByParamter(this.data.dataCode,pamdata)
                    this.tableData = res.data.data
                    console.log(this.data.fieldOptions,'this.data.fieldOptions');
                    this.headerData = JSON.parse(this.data.fieldOptions)
                }
                this.$nextTick(() => {
                    this.$refs.customTable.processData()
                })
            }
        },
    },
  };
  </script>
  <style lang="less" scoped>
  ::v-deep {
    #query_box .el-button--text{
      position: absolute;
      top: 10px;
      right: 10px;
    }
    #query_box .el-form-item{
      border: 0px;
      padding: 0px 6px 0 0 !important;
      margin: 0px;
      background: #fff;
    }
    #table_btn .el-button--text{
      position: static;
    }
  }
  </style>
  